import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TagModule } from 'primeng/tag';
import { BehaviorSubject, Observable } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-status-tag',
  template: `
    @if ({ row: columnData | async }; as $) {
      @if(hasKeyInObject($.row, 'status')) {
      <p-tag  [value]="$.row?.status === 1 ? ('COMMISSION_MANAGEMENT.STATUS.ACTIVE' | translate) : ('COMMISSION_MANAGEMENT.STATUS.INACTIVE' | translate)"
      [severity]="$.row?.status === 1 ? 'success' : 'danger'" [rounded]="true" />
      }
      @if(hasKeyInObject($.row, 'is_active')) {
      <p-tag [value]="$.row?.is_active ? ('COMMISSION_MANAGEMENT.STATUS.ACTIVE' | translate) : ('COMMISSION_MANAGEMENT.STATUS.INACTIVE' | translate)"
      [severity]="$.row?.is_active ? 'success' : 'danger'" [rounded]="true" />
      }
    }
    `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TagModule, TranslateModule, AsyncPipe]
})
export class StatusTagComponent {
  columnData: Observable<any> = new BehaviorSubject<any>(null);
  additionData: Observable<any> = new BehaviorSubject<any>(null);

  hasKeyInObject(obj: any, key: string) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  }
}


